module.exports = __webpack_public_path__ + "static/media/snowman.f510c9cb.svg";